import createResource from '@lib/resources/createResource';

const waitingRoomsResource = createResource<any>({
  key: 'waitingRooms',
  url: '/waitingRooms',
});

export default waitingRoomsResource;
